export const LEARNER_ENTERPRISE_FETCH_ERROR = 'LEARNER_ENTERPRISE_FETCH_ERROR';
export const LEARNER_ENTERPRISE_FETCH_SUCCESS = 'LEARNER_ENTERPRISE_FETCH_SUCCESS';
export const LEARNER_ENTERPRISE_USER_NOT_FOUND = 'LEARNER_ENTERPRISE_USER_NOT_FOUND';
export const LEARNER_ENTERPRISE_DEFAULT = 'LEARNER_ENTERPRISE_DEFAULT';
